export interface Environment {
  endpoint: string
}

const env: Environment = {
  endpoint: process.env.REACT_APP_JIRA_RESOURCES_ENDPOINT_BACKEND as string
}
export default env
